<div class="card mb-3">

  <div class="card-body studentticket-card-body">
    <div class="row g-0">
      <div class="flex-accordion nopadding rounded-start rounded-end" >
        <div [style]="'height:100%'">
          <ul>
            <li class="at-accordion__panel is-open">
              <div class="panel-inner" >
                <div class="title">
                  <h3 class="title__text" data-cy="accordion-ticket-title">{{ this.accordionTicketTitle }}</h3>
                  <app-traffic-light-mini class="title__light accordion-traffic-light-mini"
                                          [innerCircleColor]="getTicketStatusColor(this.ticket.status)"> </app-traffic-light-mini>
                </div>
                <app-ticket-card-details
                  class="card-content myfit"
                  [ticket]="this.ticket"
                  (addressDetailsAdjust)="onaddressDetailsAdjust()"
                  (schoolDetailsAdjust)="onSchoolDetailsAdjust()"
                  (nameDetailsAdjust)="onNameDetailsAdjust()"
                  data-cy="ticket-card-details-child"
                ></app-ticket-card-details>
              </div>
            </li>
            <li class="at-accordion__panel">
              <div class="panel-inner">
                <div class="title">
                  <h3 class="title__text" data-cy="accordion-zahlung-title">{{ this.accordionZahlungTitle }}</h3>
                  <app-traffic-light-mini class="title__light accordion-traffic-light-mini"
                                          [innerCircleColor]="getPaymentStatusColor(this.ticket?.paymentInfo?.paymentStatus?.status)"> </app-traffic-light-mini>
                </div>
                <app-ticket-payment-details
                  class="card-content myfit"
                  [ticketPaymentInfo]="this.ticket?.paymentInfo"
                  [ticketMandateInformation]="this.ticket?.mandateHolder"
                  (onMandateHolderInformationChange)="onMandateInformationChange()"
                  data-cy="ticket-payment-details-child"
                ></app-ticket-payment-details>
              </div>
            </li>
            <li class="at-accordion__panel">
              <div class="panel-inner">
                <div class="title">
                  <h3 class="title__text" data-cy="accordion-status-title">{{ this.accordionStatusTitle }}</h3>
                  <app-traffic-light-mini
                    class="title__light accordion-traffic-light-mini"
                    [innerCircleColor]="getTerminationStatusColor(ticket.terminationStatus)">
                  </app-traffic-light-mini>
                </div>
                <app-ticket-termination-details
                  class="card-content myfit"
                  [ticket]="this.ticket"
                  (onTerminateTicket)="this.terminateTicket()"
                  (onCancelTicketTermination)="this.cancelTicketTermination()"
                  data-cy="ticket-termination-details-child"
                ></app-ticket-termination-details>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>


